import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PaginationSection from "../../QuanTriHeThong/QuanLyLog/PaginationSection";
import DanhSachCuaHangTable from "./DanhSachCuaHangTable";
import React, { useEffect, useState, useRef } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import MenuChucNang from "./MenuChucNang";
import { pushNotification } from "utils/notifications";
import ThemSuaCuaHang from "./ChucNang/ThemSuaCuaHang";

const DanhSachCuaHang = () => {
  const [loading, setLoading] = useState(true);
  const [dataResponse, setdataResponse] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [hasPermission, setHasPermission] = useState(null);
  const [RoleThemMoiCuaHang, setRoleThemMoiCuaHang] = useState(null);
  const [RoleSuaCuaHang, setRoleSuaCuaHang] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  const SearchData = useRef({
    sCode: "",
    sName: "",
    sAddress: "",
    sPhone: "",
    sStatus: "",
    pageIndex: 1,
    pageSize: 20,
  });

  useEffect(() => {
    document.title = "Danh sách cửa hàng | Phần mềm quản lý cầm đồ Morman";
    fetchPermission();
  }, []);

  const fetchPermission = async () => {
    try {
      const res = await UserApi.getAllQuyen();
      const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
      setHasPermission(roles.includes("danhsachcuahang"));
      setRoleThemMoiCuaHang(roles.includes("danhsachcuahang_themmoicuahang"));
      setRoleSuaCuaHang(roles.includes("danhsachcuahang_suacuahang"));
    } catch (err) {
      console.error("Lỗi load quyền:", err);
      setHasPermission(false);
      setRoleThemMoiCuaHang(false);
      setRoleSuaCuaHang(false);
    }
  };
  const onSearch = async (data, page) => {
    try {
      setLoading(true);
      SearchData.current = { ...data, pageIndex: 1, pageSize: 20 };
      const res = await DanhSachCuaHangApi.list(SearchData.current);
      setdataResponse(res.data || []);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } catch (error) {
      console.error("Lỗi load danh sách cửa hàng:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasPermission) {
      onSearch(SearchData.current, 1);
    }
  }, [hasPermission]);

  const handlePageChange = async (pageNumber) => {
    onSearch(SearchData.current, pageNumber);
  };

  const btnThemMoiCuaHangClick = () => {
    setEditingItem({
      CompanyID: 0,
      Name: "",
      Code: "",
      Address: "",
      Phone: "",
      Status: 1,
    });
    setShowModel(true);
  };

  const btnSuaCuaHangClick = (data) => {
    setEditingItem(data);
    setShowModel(true);
  };
  if (hasPermission === null) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div className="loader loader-default is-active"></div>
          </div>
        </h2>
      </LayoutV2>
    );
  }

  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }
  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                          alt="logo"
                        />
                        <h1 className="text-info-home">
                          Quản lý đa cửa hàng - Danh sách cửa hàng
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                style={{}}
              >
                <div className="card-body card-body-v2">
                  <SearchForm onSearch={onSearch} />
                </div>
              </div>
              {loading && (
                <>
                  <div className="loader loader-default is-active"></div>
                </>
              )}
              {!loading && (
                <>
                  <div
                    className="card border-light mb-3 card-v2"
                    style={{ marginTop: "-35px" }}
                  >
                    <div
                      className="card-body card-body-v2"
                      style={{ userSelect: "text" }}
                    >
                      <div
                        className="card-body card-body-v2"
                        style={{
                          display: RoleThemMoiCuaHang ? "block" : "none",
                          marginTop: "-5px",
                          marginBottom: "10px",
                          maxHeight: "54px",
                        }}
                      >
                        <MenuChucNang
                          RoleThemMoiCuaHang={RoleThemMoiCuaHang}
                          btnThemMoiCuaHangClick={btnThemMoiCuaHangClick}
                        />
                      </div>
                      <DanhSachCuaHangTable
                        list={dataResponse}
                        pageIndex={SearchData.current.pageIndex}
                        pageSize={SearchData.current.pageSize}
                        btnSuaCuaHangClick={btnSuaCuaHangClick}
                        RoleSuaCuaHang={RoleSuaCuaHang}
                      />
                    </div>
                  </div>
                  <div
                    className="card border-light mb-3 card-v2"
                    style={{
                      marginTop: "-35px",
                    }}
                  >
                    <div
                      className="card-body card-body-v2"
                      style={{
                        display: dataResponse.iTotal === 0 ? "none" : "block",
                      }}
                    >
                      <PaginationSection
                        iTotal={dataResponse.iTotal}
                        dataSearch={SearchData.current}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {showModel && (
          <ThemSuaCuaHang
            onClose={() => setShowModel(false)}
            onSearch={() => onSearch(SearchData.current, 1)}
            data={editingItem}
          />
        )}
      </div>
    </LayoutV2>
  );
};

export default DanhSachCuaHang;
